__webpack_require__.p = "/game-of-life/";